"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextColors = exports.TextPresets = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const startCase_1 = __importDefault(require("lodash-es/startCase"));
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
var TextPresets;
(function (TextPresets) {
    TextPresets["H1"] = "h1";
    TextPresets["H2"] = "h2";
    TextPresets["H3"] = "h3";
    TextPresets["Body16"] = "body16";
    TextPresets["Body14"] = "body14";
    TextPresets["BodyBold14"] = "bodyBold14";
    TextPresets["Body12"] = "body12";
    TextPresets["BodyBold12"] = "bodyBold12";
    TextPresets["Body10"] = "body10";
    TextPresets["Caption12"] = "caption12";
    TextPresets["Caption10"] = "caption10";
})(TextPresets || (exports.TextPresets = TextPresets = {}));
var TextColors;
(function (TextColors) {
    TextColors["Default"] = "Default";
    TextColors["Inherit"] = "Inherit";
    TextColors["Gray"] = "Gray";
    TextColors["Blue"] = "Blue";
    TextColors["Black"] = "Black";
    TextColors["White"] = "White";
    TextColors["Green"] = "Green";
    TextColors["LightGray"] = "LightGray";
})(TextColors || (exports.TextColors = TextColors = {}));
const Text = ({ preset = TextPresets.Body12, tagName = 'span', children, uppercase = false, color = TextColors.Default, isEllipsis = false, }) => {
    const Tag = ((preset && (preset.includes('h') ? preset : 'span')) ||
        tagName);
    return ((0, jsx_runtime_1.jsx)(Tag, { className: (0, classnames_1.default)(styles_module_css_1.default.text, styles_module_css_1.default[`textColor${color}`], styles_module_css_1.default[`text${(0, startCase_1.default)(preset).replace(/ /g, '')}`], {
            [styles_module_css_1.default.textUppercase]: uppercase,
            [styles_module_css_1.default.textEllipsis]: isEllipsis,
        }), children: children }));
};
exports.default = Text;
